<template>
    <pt-form-list-item label="选择检测套餐：" :required="true"   @widthItem="widthItem">
        <wt-input v-if="goodsData.genePackage" v-model="goodsData.genePackage.length" data-vv-as="检测套餐" name="name"  v-validate="'required'" style="display:none"></wt-input>
            <wt-input v-else v-model="goodsData.genePackage" data-vv-as="检测套餐" name="name"  v-validate="'required'" style="display:none"></wt-input>
        <el-button  type="primary" plain @click="selectMeal" >点击选择</el-button>
        <div :class="$style['goods-table-div']" class="page-background" v-if="goodsData.genePackage&&goodsData.genePackage.length>0">
            <table :class="$style['specification-table']">
                <th>
                    <td>套餐名称</td>
                    <td>实验室检测平台</td>
                    <td>检测周期</td>
                </th>
                <tr v-for="(item,index) in goodsData.genePackage" :key="index">
                    <td>{{item.name}}</td>
                    <td>{{item.sequencingTechnologyType}}</td>
                    <td>{{item.period}}</td>
                </tr>
            </table>
        </div>
    </pt-form-list-item>
</template>
<script>
export default {
  props: {
    goodsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    selectMeal () {
      this.$emit('selectMeal')
    },
    widthItem (val) {
      this.$emit('widthItem', val)
    }
  }
}
</script>
<style module lang="less">
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
.goods-table-div{
    margin-top: 10px;
    padding: 10px 20px 30px;
}
</style>
